import { render } from "./ListarProductos.vue?vue&type=template&id=bdaf2bf6"
import script from "./ListarProductos.vue?vue&type=script&lang=js"
export * from "./ListarProductos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__